import FormattedMessage from 'I18n/components/FormattedMessage';
import { PageSection, SectionHeader, SectionSubTitle, SectionTitle } from 'pricing-pages-ui-components/semantic/PageSection';
import { CommerceFeaturesList } from './CommerceFeaturesList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CommerceFeaturesSection = () => {
  return /*#__PURE__*/_jsxs(PageSection, {
    children: [/*#__PURE__*/_jsxs(SectionHeader, {
      children: [/*#__PURE__*/_jsx(SectionTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "commerceFeaturesSection.title"
        })
      }), /*#__PURE__*/_jsx(SectionSubTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "commerceFeaturesSection.subtitle"
        })
      })]
    }), /*#__PURE__*/_jsx(CommerceFeaturesList, {})]
  });
};